import { useCallback, useEffect, useState } from "react";
import { getRoles } from "../../services/roleService";

const useRole = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getRoles();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useRole;
